import * as yup from 'yup';

export const exceptedAppsReleaseFormSchema = () =>
  yup.object().shape({
    versionName: yup.string().required('Please add the apk version name !'),
    versionCode: yup
      .number()
      .integer()
      .positive()
      .typeError('The entered version code is invalid.')
      .required('Please add the apk version code !'),
    androidMinSDKVersion: yup
      .number()
      .integer()
      .positive()
      .typeError('The entered android min SDK version is invalid.')
      .required('Please add the apk android min SDK version !'),
    androidMaxSDKVersion: yup
      .number()
      .integer()
      .positive()
      .typeError('The entered android max SDK version is invalid.')
      .required('Please add the apk android max SDK version !'),
    androidPackage: yup
      .string()
      .required('Please add an apk android package !'),
    platforms: yup
      .array()
      .test(
        'Platforms test',
        'Please select at least one platform !',
        value => !!value?.length
      )
      .required(),
    apkFiles: yup.array().min(1, 'Please add at least one apk !').required(),
    description: yup.string().required('Please add a release description !'),
    status: yup.object().nullable().required('Please select a status !'),
  });
